export default {
  security: "Security",
  reset: "Reset",
  save: "Save",
  profile: "Profile"
}